/**
 * @generated SignedSource<<ab93e4c4401252bfc311f5e57373ca45>>
 * @relayHash 161a7d2a55e64c4b7c99fe4999692923
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 42b565adcb86dacf0fe442c4ee9cfeab10c80c2fdd4bbdb4783acf60e6a4ae4d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { SolutionComposerDataProviderQuery } from './SolutionComposerDataProviderQuery.graphql';

const node: PreloadableConcreteRequest<SolutionComposerDataProviderQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "42b565adcb86dacf0fe442c4ee9cfeab10c80c2fdd4bbdb4783acf60e6a4ae4d",
    "metadata": {},
    "name": "SolutionComposerDataProviderQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
